module.exports = __webpack_public_path__ + "img/52.6f301b18.png";